<div class="text-center">
    <img class="empty-list" src="assets/images/list-empty.png">
    <p>{{message}}</p>
</div>